import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { EcommerceConfigService } from 'idt-ecommerce-api/config/ecommerce-config.service';

import { RequestParams } from './api-request.models';


@Injectable()
export class ApiRequestService {

  constructor(
    private readonly ecommerceConfigService: EcommerceConfigService
  ) {}

  /**
   * @deprecated Use EcommerceUrlResolverService instead
   */
  public requestUrl(
    slug: string,
    languageId?: string,
    customParams?: RequestParams,
    addTimestamp?: boolean,
    apiVersion?: string
  ): Observable<string> {
    const config = this.ecommerceConfigService.getConfig();
    const baseUrl = apiVersion ? config.apiBaseUrl.replace('itxrest/2', `itxrest/${apiVersion}`) : config.apiBaseUrl;
    const params = this.buildParams(config.appId.toString(), languageId, customParams, addTimestamp);
    const url = `${baseUrl}/${slug}?${params}`;
    return of(url); // TODO: this no longer needs to be an observable
  }

  public brandId(): Observable<string> {
    return of(this.ecommerceConfigService.getConfig().brandSettings.brandId); // TODO: this no longer needs to be an observable
  }

  private buildParams(appId: string, languageId?: string, customParams?: RequestParams, addTimestamp: boolean = false): string {
    let params: RequestParams = [{ key: 'appId', value: appId }];

    if (isDefined(languageId)) {
      params = [{ key: 'languageId', value: languageId }, ...params];
    }

    if (isDefined(customParams)) {
      params = [...params, ...customParams];
    }

    // Workaround: IE saves in cache Ajax Responses
    // https://www.google.com/search?q=internet+explorer+caching+ajax+calls&rlz=1C1GCEA_enES789ES790&oq=Internet+explorer+caching+
    if (addTimestamp) {
      const ts: string = new Date().getTime().toString();
      params = [...params, { key: 'ts', value: ts }];
    }

    const paramsString = params
      .map((i) => `${encodeURIComponent(i.key)}=${encodeURIComponent(i.value)}`)
      .join('&');

    return paramsString;
  }

}
